import React from "react";
import classNames from "classnames/bind";
import Styles from "./Footer.module.scss";
import Image from "../../components/Image/Image";
import images from "../../assets/images/images";
import { MdOutlineEmail } from "react-icons/md";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import useResponsive from "../../hooks/useResponsive";

const cx = classNames.bind(Styles);

const Footer = () => {
  const isDesktop = useResponsive("up", 960);

  return (
    <div className={cx("wrapper")}>
      <div className={cx("footer-header")}>
        <div className={cx("footer-left")}>
          <span className={cx("footer-left-title")}>CódigoLactancia</span>
          <span className={cx("footer-left-content")}>
            Es una innovadora plataforma digital diseñada para monitorear de
            forma automatizada el cumplimiento de la normatividad internacional
            y nacional relacionada con la comercialización de alimentos y
            bebidas dirigidos a lactantes, niñas y niños de corta edad en
            entornos virtuales, además de la recepción, procesamiento y
            seguimiento de denuncias provenientes de particulares sobre posibles
            infracciones a estas normativas, tanto en entornos digitales como
            físicos.
          </span>
          <div className={cx("footer-social")}>
            <Link to="/" className={cx("footer-social-item")}>
              <FontAwesomeIcon
                icon={faGlobe}
                className={cx("footer-social-icon")}
              />
            </Link>
            <Link to="/" className={cx("footer-social-item")}>
              <FaFacebook className={cx("footer-social-icon")} />
            </Link>
            <Link to="/" className={cx("footer-insta-item")}>
              <FaInstagram className={cx("footer-insta-icon")} />
            </Link>
          </div>
        </div>
        {isDesktop ? (
          <div className={cx("footer-right")}>
            <span className={cx("footer-right-title")}>
              Organización De Asociación
            </span>
            <div className={cx("footer-right-logo-row1")}>
              <Image
                src={images.logoFooterReyhan}
                className={cx("footer-right-img-uniform")}
                alt="Logo Footer Reyhan"
              />
              <Image
                src={images.logoFooterAlsanna}
                className={cx("footer-right-img-uniform")}
                alt="Logo Footer Alsanna"
              />
              <Image
                src={images.logoFooterConsejoNuevoLeon}
                className={cx("footer-right-img-uniform")}
                alt="Logo Footer Consejo Nuevo Leon"
              />
              <Image
                src={images.logoFooter9}
                className={cx("footer-right-img-uniform")}
                alt="Logo Footer"
              />
              <Image
                src={images.logoFooter3}
                className={cx("footer-right-img-uniform")}
                alt="Logo Footer"
              />
              <Image
                src={images.logoFooterIbfan}
                className={cx("footer-right-img-uniform")}
                alt="Logo Footer IBFAN"
              />
            </div>
            <div className={cx("footer-right-logo-row2")}>
              <Image
                src={images.logoFooter5}
                className={cx("footer-right-img-uniform")}
                alt="Logo Footer"
              />
              <Image
                src={images.logoFooter4}
                className={cx("footer-right-img-uniform")}
                alt="Logo Footer"
              />
              <Image
                src={images.logoFooterCensia}
                className={cx("footer-right-img-uniform")}
                alt="Logo Footer Censia"
              />
              <Image
                src={images.logoFooter7}
                className={cx("footer-right-img-uniform")}
                alt="Logo Footer"
              />
              <Image
                src={images.logoFooterEPC}
                className={cx("footer-right-img-uniform")}
                alt="Logo Footer EPC"
              />
            </div>
            <div className={cx("footer-right-logo-row3")}>
              <Image
                src={images.logoFooter8}
                className={cx("footer-right-img-uniform")}
                alt="Logo Footer"
              />
              <Image
                src={images.logoFooter1}
                className={cx("footer-right-img-uniform")}
                alt="Logo Footer"
              />
              <Image
                src={images.logoFooterSalud}
                className={cx("footer-right-img-uniform")}
                alt="Logo Footer Salud"
              />
              <Image
                src={images.logoFooterUAM}
                className={cx("footer-right-img-uniform")}
                alt="Logo Footer UAM"
              />
              <Image
                src={images.logoFooter6}
                className={cx("footer-right-img-uniform")}
                alt="Logo Footer"
              />
              <Image
                src={images.logoFooter2}
                className={cx("footer-right-img-uniform")}
                alt="Logo Footer"
              />
            </div>
          </div>
        ) : (
          <div className={cx("footer-right-mobile")}>
            <span className={cx("footer-right-title-mobile")}>
              Organización De Asociación
            </span>
            <div className={cx("footer-right-logo-mobile")}>
              <Image
                src={images.logoFooterReyhan}
                className={cx("footer-right-img-uniform-mobile")}
                alt="Logo Footer Reyhan"
              />
              <Image
                src={images.logoFooterAlsanna}
                className={cx("footer-right-img-uniform-mobile")}
                alt="Logo Footer Alsanna"
              />
              <Image
                src={images.logoFooterConsejoNuevoLeon}
                className={cx("footer-right-img-uniform-mobile")}
                alt="Logo Footer Consejo Nuevo Leon"
              />
              <Image
                src={images.logoFooter9}
                className={cx("footer-right-img-uniform-mobile")}
                alt="Logo Footer"
              />
              <Image
                src={images.logoFooter3}
                className={cx("footer-right-img-uniform-mobile")}
                alt="Logo Footer"
              />
              <Image
                src={images.logoFooterIbfan}
                className={cx("footer-right-img-uniform-mobile")}
                alt="Logo Footer IBFAN"
              />
              <Image
                src={images.logoFooter5}
                className={cx("footer-right-img-uniform-mobile")}
                alt="Logo Footer"
              />
              <Image
                src={images.logoFooter4}
                className={cx("footer-right-img-uniform-mobile")}
                alt="Logo Footer"
              />
              <Image
                src={images.logoFooterCensia}
                className={cx("footer-right-img-uniform-mobile")}
                alt="Logo Footer Censia"
              />
              <Image
                src={images.logoFooter7}
                className={cx("footer-right-img-uniform-mobile")}
                alt="Logo Footer"
              />
              <Image
                src={images.logoFooterEPC}
                className={cx("footer-right-img-uniform-mobile")}
                alt="Logo Footer EPC"
              />
              <Image
                src={images.logoFooter8}
                className={cx("footer-right-img-uniform-mobile")}
                alt="Logo Footer"
              />
              <Image
                src={images.logoFooter1}
                className={cx("footer-right-img-uniform-mobile")}
                alt="Logo Footer"
              />
              <Image
                src={images.logoFooterSalud}
                className={cx("footer-right-img-uniform-mobile")}
                alt="Logo Footer Salud"
              />
              <Image
                src={images.logoFooterUAM}
                className={cx("footer-right-img-uniform-mobile")}
                alt="Logo Footer UAM"
              />
              <Image
                src={images.logoFooter6}
                className={cx("footer-right-img-uniform-mobile")}
                alt="Logo Footer"
              />
              <Image
                src={images.logoFooter2}
                className={cx("footer-right-img-uniform-mobile")}
                alt="Logo Footer"
              />
            </div>
          </div>
        )}
      </div>

      <div className={cx("footer-desc")}>
        <div className={cx("footer-desc-left")}>Aviso de privacidad</div>
        <div className={cx("footer-desc-right")}>
          Los derechos de autor de las ilustraciones pertenecen aI Instituto
          Nacional de Salud Pública
        </div>
      </div>
    </div>
  );
};

export default Footer;
